import { useFeatureFlag } from '@moda/portal-stanchions';

type PasswordValidationArgs = {
  requiredMessage?: string;
};

export const usePasswordValidation = (args?: PasswordValidationArgs) => {
  const minLength = useFeatureFlag('password-min-length', [{ default: 6 }, { if: true, then: 10 }]);

  return {
    minLength,
    passwordValidation: {
      required: {
        message: args?.requiredMessage ?? 'Please enter a password.',
        value: true
      },
      minLength: {
        message: `Password must be at least ${minLength} characters.`,
        value: minLength
      },
      pattern: {
        message: 'Password should not contain any special characters.',
        value: /^[^{}[\]"'`,:]+$/
      }
    }
  };
};
